<template>
    <div class="card border-0 rounded-0 bg-white todays-course-box"
        :class="{ 'detail-visible': survey_detail !== undefined }">
        <div
            class="card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25 letter-spacing d-flex flex-column survey-card">
            <div class="mb-10 d-flex justify-content-between">
                <div class="title">
                    <h5 class="fw-medium text-black-emphasis mb-0">
                        {{ survey.title }}</h5>
                </div>
            </div>
            <p v-if="env !== 'kareena'"> {{ survey.description }}</p>
            <div class="d-flex align-items-center gap-3"
                :class="survey.has_override_settings || !survey.has_override_settings ? 'justify-content-between' : ''">
                <template v-if="env == 'kareena' && survey.extra?.group === 'sintomi' && survey.priority_enabled !== false && update_enabled">
                    <button v-if="!survey.has_override_settings" type="button"
                        class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium" data-bs-toggle="modal"
                        :data-bs-target="'#confirmModal' + survey.id">
                        <i class="ph ph-arrow-fat-line-up text-warning lh-1 me-1 position-relative top-2"></i>
                        <span class="position-relative">{{ $t("feature.surveys.set_priority") }}</span>
                    </button>
                    <div v-else>
                        <i class="ph ph-arrow-fat-line-up text-success"></i>
                    </div>
                </template>
                <button type="button" v-if="survey_detail === undefined" @click="showDetail"
                    class="ms-auto card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block">
                    {{ $t("cta.view") }}
                </button>
                <button v-else type="button" class="btn-close ms-auto" @click="survey_detail = undefined">
                </button>
            </div>
        </div>
        <div v-if="survey_detail !== undefined" class="survey-detail">
            <SurveyView :survey="survey_detail" :patient_id="patient.id!" :show_description="false" />
        </div>
    </div>
    <ConfirmModal @confirm="setSurveyPriority(survey.id, true)" :key="survey.id" :title="$t('cta.$delete.title')"
        :message="$t('feature.surveys.modal_message')" :id="'confirmModal' + survey.id" />
</template>

<style lang="scss" scoped>
.survey-detail {
    margin-top: -1rem;
}
</style>

<script lang="ts">
import API from '@/services/api/api.service';
import { Survey } from '@/utils/models/survey.model';
import { PatientInfo } from '@/utils/models/user.model';
import DateFormatUtils from "@/utils/methods/date_formats";
import { defineComponent, PropType } from 'vue';
import { CLIENT, Environment } from '@/utils/const/env';
import ConfirmModal from '@/components/Widgets/ConfirmModal.vue';
import SurveyView from "@/components/FK/Surveys/SurveyView.vue";
import stateStore from '@/utils/store';

export default defineComponent({
    name: 'SurveyCard',
    props: {
        survey: {
            type: Object as PropType<Survey>,
            required: true
        }
    },
    emits: ['priority'],
    data: function () {
        return {
            survey_detail: undefined
        } as {
            survey_detail: undefined | Survey
        }
    },
    mounted() {
        if (this.survey.has_override_settings === true) {
            this.showDetail();
        }
    },
    methods: {
        async setSurveyPriority(surveyId: number, isPrioritary: boolean) {
            let patientId = this.$route.params.id;
            API.setSurveySettings({ patient_Id: patientId, survey_Id: surveyId, center_Id: this.patient.center_id, isPrioritary: isPrioritary }).then(
                (res) => {
                    if (res.data.message == true) {
                        this.$emit('priority');
                        this.showDetail();
                    }
                }

            )
        },
        formatTime(date: Date) {
            return DateFormatUtils.HHmm(date);
        },
        titlecase(text: string) {
            return `${text.slice(0, 1).toUpperCase()}${text.slice(1)}`
        },
        showDetail() {
            API.getSurvey(this.survey.id.toString()).then((response) => {
                if (response.data.success === true) {
                    this.survey_detail = response.data.data;
                }
            })
        }
    },
    computed: {
        patient() { return this.$route.meta.patient as PatientInfo },
        env(): Environment { return CLIENT },
        update_enabled(): boolean { return stateStore.getCenterPermission((this.$route.meta.patient as PatientInfo).center_id, 'update') },
    },
    components: {
        ConfirmModal,
        SurveyView
    }
})
</script>

<style scooped>
.survey-card i {
    font-size: 23px;
}
</style>